import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { Star, ArrowRight, Award } from 'lucide-react';

const Reviews = () => {
  const reviews = [
    {
      slug: 'pub-casino',
      name: 'PUB Casino',
      bonus: '100% up to £100',
      rating: 4.5,
      description: 'A classic pub atmosphere meets modern online gaming. PUB Casino delivers authentic British casino experiences with generous bonuses and reliable service.',
      color: 'from-red-600 to-red-800'
    },
    {
      slug: 'nrg',
      name: 'NRG',
      bonus: '200% on first deposit + 100 free spins',
      rating: 4.8,
      description: 'High-energy gaming with one of the most generous welcome packages in the UK. NRG combines explosive bonuses with premium game selection.',
      color: 'from-orange-600 to-red-600'
    },
    {
      slug: 'mr-play',
      name: 'Mr.Play',
      bonus: '100 spins + 100% up to £200 bonus',
      rating: 4.7,
      description: 'Premium entertainment with a welcome package that keeps giving. Mr.Play offers sophisticated gaming experiences backed by exceptional service.',
      color: 'from-purple-600 to-red-600'
    }
  ];

  return (
    <div className="min-h-screen bg-regal-dark">
      <Header />
      <main className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16 max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
              Expert Casino Reviews
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
              In-depth reviews of the UK's top online casinos. We test platforms, verify bonuses, and evaluate every aspect that matters to players.
            </p>
          </div>

          {/* Reviews Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {reviews.map((review) => (
              <Link
                key={review.slug}
                to={`/reviews/${review.slug}`}
                data-discover="true"
                className="bg-regal-gray rounded-xl overflow-hidden border border-gray-800 hover:border-regal-red transition-all transform hover:scale-105 block group"
              >
                <div className={`bg-gradient-to-r ${review.color} p-6 flex items-center justify-between`}>
                  <div className="flex items-center gap-3">
                    <Award className="w-8 h-8 text-white" />
                    <span className="text-white font-bold text-lg">{review.name}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                    <span className="text-white font-semibold">{review.rating}</span>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="mb-4">
                    <span className="text-regal-red font-bold text-xl">{review.bonus}</span>
                  </div>
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {review.description}
                  </p>
                  <div className="flex items-center text-regal-red font-semibold">
                    <span>Read Full Review</span>
                    <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Reviews;

